module.exports = __webpack_public_path__ + "img/Shipping Agent Service.fc0dbb10.png";